import { render, staticRenderFns } from "./BookInterview.vue?vue&type=template&id=70056286&"
import script from "./BookInterview.vue?vue&type=script&lang=ts&"
export * from "./BookInterview.vue?vue&type=script&lang=ts&"
import style0 from "./BookInterview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports